import ninegrid from "../index.js";
import { ngElement } from './_ngElements.js';

export class ngCellEx extends ngElement
{

	#showIcon;
	#showCheck;
	#showButton;
	#expandButton;

	constructor () {
		super();
	}
	
	connectedCallback() {

		super.connectedCallback();

		let host = this.getRootNode().host;
		if (host && host.tagName != "NINE-GRID") host = host.getRootNode().host;

		this.owner	= (host && host.tagName == "NINE-GRID") ? host : null;//this.closest("nine-grid");
		this.cell	= this.closest("th,td");

		if (this.cell && this.shadowRoot) {
			this.#showIcon		= this.getAttribute("show-icon")	== "true" || this.cell.getAttribute("show-icon") == "true";
			this.#showCheck		= this.getAttribute("show-check")	== "true" || this.cell.getAttribute("show-check") == "true";
			this.#showButton	= this.getAttribute("show-button")	== "true" || this.cell.getAttribute("show-button") == "true";

			if (this.cell.dataset.bind) ninegrid.j.querySelectorAll(this).addClass(this.cell.dataset.bind);
			
			const style		= this.shadowRoot.querySelector("style");
			const textAlign = this.getAttribute("text-align") || this.cell.getAttribute("text-align") || "left";
			ninegrid.j.querySelectorAll(this).addClass(`ng-${textAlign}`);

			if (this.#showIcon) {
				const iconType		= this.getAttribute("icon-type")		|| this.cell.getAttribute("icon-type")		|| "sphere";
				const iconSize		= this.getAttribute("icon-size")		|| this.cell.getAttribute("icon-size")		|| "8";
				const iconWidth		= this.getAttribute("icon-width")		|| this.cell.getAttribute("icon-width")		|| this.getAttribute("icon-size")	|| this.cell.getAttribute("icon-size")	|| "8";
				const iconHeight	= this.getAttribute("icon-height")		|| this.cell.getAttribute("icon-height")	|| this.getAttribute("icon-size")	|| this.cell.getAttribute("icon-size")	|| "8";
				const iconColor		= this.getAttribute("icon-color")		|| this.cell.getAttribute("icon-color")		|| "gray";
				const iconPosition	= this.getAttribute("icon-position")	|| this.cell.getAttribute("icon-position")	|| "left-first";
				const isLeft		= iconPosition.startsWith("left");
				const tmpl			= `<ng-expand-icon class="ng-${isLeft ? 'left' : 'right'} ng-${iconPosition}" type="${iconType}" size="${iconSize}" width="${iconWidth}" height="${iconHeight}" color="${iconColor}"></ng-expand-icon>`;
				
				(isLeft) ? (style ? $(style).after(tmpl) : $(this.shadowRoot).prepend(tmpl)) : $(this.shadowRoot).append(tmpl);
			}

			if (this.#showCheck) {
				const checkPosition = this.getAttribute("check-position") || this.cell.getAttribute("check-position") || "left-first";
				const isLeft		= checkPosition.startsWith("left");
				const expandIcon	= this.shadowRoot.querySelector(`.ng-${isLeft ? 'left' : 'right'}`);
				const expandFirst	= this.shadowRoot.querySelector(`.ng-${isLeft ? 'left' : 'right'}-first`);
				const expandSecond	= this.shadowRoot.querySelector(`.ng-${isLeft ? 'left' : 'right'}-second`);
				const expandThird	= this.shadowRoot.querySelector(`.ng-${isLeft ? 'left' : 'right'}-third`);
				const tmpl			= `<ng-expand-check class="ng-${isLeft ? 'left' : 'right'} ng-${checkPosition}"></ng-expand-check>`;
				
				if (isLeft) {
					//(expandIcon && !checkPosition.endsWith("first")) ? $(expandIcon).after(tmpl) : $(this.shadowRoot).prepend(tmpl);
					if (expandIcon && checkPosition.endsWith("second")) {
						(expandSecond || expandFirst) ? $(expandSecond || expandFirst).after(tmpl) : (style ? $(style).after(tmpl) : $(this.shadowRoot).prepend(tmpl));
					}
					else if (expandIcon && checkPosition.endsWith("third")) {
						(expandThird || expandSecond || expandFirst) ? $(expandThird || expandSecond || expandFirst).after(tmpl) : (style ? $(style).after(tmpl) : $(this.shadowRoot).prepend(tmpl));
					}
					else {
						style ? $(style).after(tmpl) : $(this.shadowRoot).prepend(tmpl);
					}
				}
				else {
					//(expandIcon && checkPosition.endsWith("first")) ? $(expandIcon).before(tmpl) : $(this.shadowRoot).append(tmpl);
					if (expandIcon && checkPosition.endsWith("first")) {
						(expandFirst || expandSecond || expandThird) ? $(expandFirst || expandSecond || expandThird).before(tmpl) : $(this.shadowRoot).append(tmpl);
					}
					else if (expandIcon && checkPosition.endsWith("second")) {
						(expandSecond || expandThird) ? $(expandSecond || expandThird).before(tmpl) : $(this.shadowRoot).append(tmpl);
					}
					else {
						$(this.shadowRoot).append(tmpl);
					}
				}
			}
			
			if (this.#showButton) {
				const buttonText		= this.getAttribute("button-text")		|| this.cell.getAttribute("button-text");
				const buttonWidth		= this.getAttribute("button-width")		|| this.cell.getAttribute("button-width");
				const buttonImage		= this.getAttribute("button-image")		|| this.cell.getAttribute("button-image");
				const buttonPosition	= this.getAttribute("button-position")	|| this.cell.getAttribute("button-position") || "right-third";
				const isLeft			= buttonPosition.startsWith("left");
				const expandIcon		= this.shadowRoot.querySelector(`.ng-${isLeft ? 'left' : 'right'}`);
				const expandFirst		= this.shadowRoot.querySelector(`.ng-${isLeft ? 'left' : 'right'}-first`);
				const expandSecond		= this.shadowRoot.querySelector(`.ng-${isLeft ? 'left' : 'right'}-second`);
				const expandThird		= this.shadowRoot.querySelector(`.ng-${isLeft ? 'left' : 'right'}-third`);
				const tmpl				= `<ng-expand-button class="ng-${isLeft ? 'left' : 'right'} ng-${buttonPosition}"></ng-expand-button>`;

				if (isLeft) {
					if (expandIcon && buttonPosition.endsWith("second")) {
						(expandSecond || expandFirst) ? $(expandSecond || expandFirst).after(tmpl) : (style ? $(style).after(tmpl) : $(this.shadowRoot).prepend(tmpl));
					}
					else if (expandIcon && buttonPosition.endsWith("third")) {
						(expandThird || expandSecond || expandFirst) ? $(expandThird || expandSecond || expandFirst).after(tmpl) : (style ? $(style).after(tmpl) : $(this.shadowRoot).prepend(tmpl));
					}
					else {
						style ? $(style).after(tmpl) : $(this.shadowRoot).prepend(tmpl);
					}
				}
				else {
					if (expandIcon && buttonPosition.endsWith("first")) {
						(expandFirst || expandSecond || expandThird) ? $(expandFirst || expandSecond || expandThird).before(tmpl) : $(this.shadowRoot).append(tmpl);
					}
					else if (expandIcon && buttonPosition.endsWith("second")) {
						(expandSecond || expandThird) ? $(expandSecond || expandThird).before(tmpl) : $(this.shadowRoot).append(tmpl);
					}
					else {
						$(this.shadowRoot).append(tmpl);
					}
				}
				
				this.#expandButton = this.shadowRoot.querySelector("ng-expand-button").shadowRoot.querySelector("button");
				
				if (buttonText) {
					$(this.#expandButton).text(buttonText);
				}
				
				if (buttonWidth) {
					$(this.#expandButton).css({ "width" : buttonWidth });
				}
				
				if (["NG-INPUT","NG-TEXTAREA"].includes(this.tagName) && !buttonImage) {

					const prev = this.shadowRoot.querySelector("input[type=text],textarea").previousElementSibling;
					const next = this.shadowRoot.querySelector("input[type=text],textarea").nextElementSibling;
					
					if (prev.tagName == "NG-EXPAND-BUTTON") {
						ninegrid.j.querySelectorAll(this.shadowRoot.querySelector("input[type=text],textarea")).addClass("border-left-none");
						ninegrid.j.querySelectorAll(prev).addClass("border-right-none");
					}
					else if (next.tagName == "NG-EXPAND-BUTTON") {
						ninegrid.j.querySelectorAll(this.shadowRoot.querySelector("input[type=text],textarea")).addClass("border-right-none");
						ninegrid.j.querySelectorAll(next).addClass("border-left-none");
					}
				}
			}
			
			const expandleft = this.shadowRoot.querySelectorAll(".ng-left");
			if (expandleft.length > 0) ninegrid.j.querySelectorAll(expandleft[0]).addClass("ng-first");
			const expandRight = this.shadowRoot.querySelectorAll(".ng-right");
			if (expandRight.length > 0) ninegrid.j.querySelectorAll(expandRight[expandRight.length-1]).addClass("ng-last");
			
			
			
			if (this.closest("tbody") && this.cell.dataset.bind) {
				const ngExpandCheck = this.shadowRoot.querySelector("ng-expand-check");
				
				if (ngExpandCheck) {
					$("input", ngExpandCheck.shadowRoot).on("change", e => {

						var rowData = this.cell.closest("tr").data;

						rowData.__ng.c[this.cell.dataset.bind] = $(e.target).is(':checked') ? true : false;
					});
				}
			}
		}
		
		/**
		if (this.#expandButton) {
			$(this.#expandButton).on("click", e => {
				let fn = this.getAttribute("onbuttonclick") || this.getAttribute("onButtonClick") || this.cell.getAttribute("onbuttonclick") || this.cell.getAttribute("onButtonClick");// || this.getAttribute("@onlinkclick");
				
				if (fn) {
					fn = fn.replace("()","");
					
					if (this.owner[fn]) {
						this.owner[fn].call(this.owner, this.cell.closest("tr").data, parseInt(this.cell.dataset.row), this.cell);
					}
					else {
						this.owner.exprFunction(fn).call(this, this.cell.closest("tr").data, parseInt(this.cell.dataset.row));
					}
				}
				
				this.owner.dispatchEvent(new CustomEvent(ninegrid.EVENT.BUTTON_CLICK, { detail: { target: this.cell, data: this.cell.closest("tr").data, currow: parseInt(this.cell.dataset.row) }, bubbles: true, composed: true }));
				//var row = parseInt(this.cell.dataset.row);
				//this.owner.exprFunction(this.cell.getAttribute("onButtonClick") || this.getAttribute("onButtonClick")).call(this, this.cell.closest("tr").data, row);
			});
		} */

		this.shadowRoot.querySelectorAll("button,ng-expand-button").forEach(button => {

			$(button).on("click", e => {

				let fn = this.getAttribute("onbuttonclick") || this.getAttribute("onButtonClick") || this.cell?.getAttribute("onbuttonclick") || this.cell?.getAttribute("onButtonClick");// || this.getAttribute("@onlinkclick");

				if (fn && this.owner) {

					fn = fn.replace("()","");

					const match = fn.match(/^(\w+)\s*\(/);
					// match가 null이면 undefined 반환, 아니면 [1] 반환
					const methodName = match?.[1];

					if (this.owner[methodName]) {
						this.owner[methodName].call(this.owner, this.cell.closest("tr").data, parseInt(this.cell.dataset.row), this.cell);
					}
					else {
						this.owner.exprFunction(fn).call(this, this.cell.closest("tr").data, parseInt(this.cell.dataset.row));
					}
				}

				this.owner?.dispatchEvent(new CustomEvent(ninegrid.EVENT.BUTTON_CLICK, { detail: { target: this.cell, data: this.cell.closest("tr").data, currow: parseInt(this.cell.dataset.row) }, bubbles: true, composed: true }));
				//var row = parseInt(this.cell.dataset.row);
				//this.owner.exprFunction(this.cell.getAttribute("onButtonClick") || this.getAttribute("onButtonClick")).call(this, this.cell.closest("tr").data, row);
			});
		});

		
		var renderer = this.shadowRoot.querySelector(".renderer");
		if (renderer) {
			let fn = this.getAttribute("onlinkclick") || this.getAttribute("onLinkClick");// || this.getAttribute("@onlinkclick");
			
						
			if (this.getAttribute("link") == "true") {
				ninegrid.j.querySelectorAll(renderer).addClass("link");

				renderer.addEventListener("click", e => {
					
					if (fn) {
						fn = fn.replace("()","");

						const match = fn.match(/^(\w+)\s*\(/);
						// match가 null이면 undefined 반환, 아니면 [1] 반환
						const methodName = match?.[1];

						console.log(methodName);

						if (this.owner[methodName]) {
							this.owner[methodName].call(this.owner, this.cell.closest("tr").data, parseInt(this.cell.dataset.row), this.cell);
						}
						else {
							this.owner.exprFunction(fn).call(this, this.cell.closest("tr").data, parseInt(this.cell.dataset.row));
						}
					}
					
					this.owner.dispatchEvent(new CustomEvent(ninegrid.EVENT.LINK_CLICK, { detail: { target: this.cell, data: this.cell.closest("tr").data, currow: parseInt(this.cell.dataset.row) }, bubbles: true, composed: true }));
				});
			}
			
			/**
			$(".icon", this.shadowRoot).children().hide();
			if (this.getAttribute("has-icon") == "true") {
				$("ng-" + (this.getAttribute("icon-type") || "sphere"), this.shadowRoot).show();
			}
			else {
				$(".icon", this.shadowRoot).hide();
			} */
		}
	};
	
	get value() {
		var v = (!this.owner || !this.owner.dataManager || !this.cell || !this.cell.dataset || !this.cell.dataset.row || !this.cell.dataset.bind) ? "" : this.cell.closest("tr").data[this.cell.dataset.bind];
		return (v == null) ? "" : v;
	};
	set value(v) {
				
		var row = parseInt(this.cell.dataset.row);
		
		const updateRowState = this.getAttribute('update-row-state') == "false" ? false : true;
		const isPin = row < 0;

		if (isPin) {
			this.owner.data.setValueNF(parseInt(this.cell.dataset.index), this.cell.dataset.bind, v, updateRowState);
		}
		else {
			this.owner.data.setValue(row, this.cell.dataset.bind, v, updateRowState);
		}
	}

	get row() {
		return parseInt(this.cell.dataset.row);
	}
	get data() {
		return this.cell.closest("tr").data;
	}
	
	getDisplayText = (defaultValue) => {

		if (!this.cell) return;
		
		if (this.cell.closest("tbody")) {
			const rowData = this.cell.closest("tr").data;
			const row = parseInt(this.cell.dataset.row);
			
			if (!rowData) return "";

			//console.log(this.cell.dataset.expr, this.cell.dataset.bind, ninegrid.ROW.ORDER);
			
			if (!ninegrid.isNull(this.cell.dataset.expr)) {
				
				try {
					//console.log(this.cell.dataset.expr);
					
					/**
					const fn = this.cell.dataset.expr.replace("()", "");
					if (this.owner[fn]) {
						return this.owner[fn].call(this, rowData, row,  this.cell);
					} */
					
					//return this.owner.exprFunction(this.cell.dataset.expr).call(this, rowData, this.cell.dataset.row);
					return this.getExprValue(this.cell.dataset.expr, rowData, row, this.cell);
				} catch {
					console.error(this.cell.dataset.expr, rowData, this.cell.dataset.row);
				}
			}
			else if (!ninegrid.isNull(this.cell.dataset.bind)) {
				return rowData[this.cell.dataset.bind] || ninegrid.nvl(defaultValue, "");
			}
	
			return ninegrid.nvl(defaultValue, "");
		}
		else {
			try {
				return this.owner.exprFunction(this.cell.dataset.expr).call(this, null, -1, this.owner.data);
			} catch(e) {
				//console.error(this.cell, e);
			}
			
		}
	};
	
	reset = () => {

		var row = parseInt(this.cell.dataset.row);
		var tr = this.cell.closest("tr");
		var data = tr.data;
		if (!data) {
			data = this.owner.data.get(row);
			this.owner.body.querySelectorAll(`.ng-container tbody tr[data-row="${row}"]`).forEach(tr => {
				tr.data = data;
			});
		}
		
		if (this.cell.dataset.bind && this.shadowRoot.querySelector("input,textarea,button")) {
			ninegrid.j.querySelectorAll(this.cell).removeClass("ng-changed");

			if (data.__ng.o.hasOwnProperty(this.cell.dataset.bind)) {
				if (data[this.cell.dataset.bind] != data.__ng.o[this.cell.dataset.bind]) {
					ninegrid.j.querySelectorAll(this.cell).addClass("ng-changed");
				}
			}
		}
		
		if ((this.getAttribute("show-icon") || this.cell.getAttribute("show-icon")) == "true") {
			
			var expr = this.getAttribute("icon-color") || this.cell.getAttribute("icon-color");
			if (expr) {
				var color = this.getExprValue(expr, data, row);//this.owner.exprFunction(expr).call(this, this.owner.data.get(this.cell.dataset.row), this.cell.dataset.row);
				//$(`ng-expand-icon`, this.shadowRoot).attr("color", color);
				this.shadowRoot.querySelector(`ng-expand-icon`).setAttribute("color", color);
			}

			var expr = this.getAttribute("icon-src") || this.cell.getAttribute("icon-src");
			if (expr) {
				var src = this.getExprValue(expr, data, row);//this.owner.exprFunction(expr).call(this, this.owner.data.get(this.cell.dataset.row), this.cell.dataset.row);
				this.shadowRoot.querySelector(`ng-expand-icon`).setAttribute("src", src);
			}
		}
		
		if (this.#expandButton) {
			var expr = this.getAttribute("button-image") || this.cell.getAttribute("button-image");
			if (expr) {
				var src = this.getExprValue(expr, data, row);//this.owner.exprFunction(expr).call(this, this.owner.data.get(this.cell.dataset.row), this.cell.dataset.row);

				if (src) {
					$(this.#expandButton).text("");
					$(this.#expandButton).css({
						"border"			: "none",
						"background-color"	: "transparent",
						"background-image"	: src.startsWith("<svg") ? `url('data:image/svg+xml;utf8,${src}')` : `url("${src}")`,
					});
				}
			}
		}
		

		
		var expr = this.getAttribute("class-expr");
		if (expr) {
			this.classList.forEach(v => {
			    if (!["aaa"].includes(v)) {
			    	this.classList.remove(v);
			    }
			});
			
			var exprValue = this.getExprValue(expr, data, row);
			if (exprValue) this.classList.toggle(exprValue);
		}
		//////////////////
		
		var expr = this.cell.getAttribute('enable-check');
		if (expr) {
			var o = this.shadowRoot.querySelector('ng-expand-check');
			
			if (o) {
				 o.shadowRoot.querySelector("input").setAttribute("disabled", !this.getExprValue(expr, data, row));
			}
		}
		
		var expr = this.cell.getAttribute('enable-button');
		if (expr) {
			var o = this.shadowRoot.querySelector('ng-expand-button');
			if (o) {
				o.shadowRoot.querySelector("button").setAttribute("disabled", !this.getExprValue(expr, data, row));
			}
		}

		var expr = this.getAttribute('visible') || this.cell.getAttribute('visible');
		if (expr) {
			this.getExprValue(expr, data, row) ? ninegrid.j.querySelectorAll(this.cell).removeClass('hidden') : ninegrid.j.querySelectorAll(this.cell).addClass('hidden');
		}
		else {
			ninegrid.j.querySelectorAll(this.cell).removeClass('hidden');
		}

		var expr = this.getAttribute('enable') || this.cell.getAttribute('enable');
		if (expr) {
			ninegrid.j.querySelectorAll("input,textarea,button", this.shadowRoot).attr("disabled", !this.getExprValue(expr, data, row));
		}
		else {
			ninegrid.j.querySelectorAll("input,textarea,button", this.shadowRoot).attr("disabled", false);
		}
		
		var expr = this.getAttribute('readonly') || this.cell.getAttribute('readonly');
		if (expr) {
			ninegrid.j.querySelectorAll("input,textarea", this.shadowRoot).attr("readonly", this.getExprValue(expr, data, row));
		}
		else {
			ninegrid.j.querySelectorAll("input,textarea,button", this.shadowRoot).attr("readonly", false);
		}
		

		["color","background-color","class"].forEach(v => {
			var expr = this.cell.getAttribute(v);
			if (expr) {
				$(this.cell).css({
					[v] : this.getExprValue(expr, data, row),
				});
			}
		});
		
		
		
		$(this.cell).children().each((i,el) => {
			var tooltipFn = el.getAttribute('tooltip');
			if (tooltipFn) {
				ninegrid.j.querySelectorAll(el).attr("title", this.owner.exprFunction(tooltipFn).call(this, this.cell.closest("tr").data, row));
			}
		});
		
		this.#resetSuppress();
	}
	
	#resetSuppress = () => {

		if (!this.owner || !this.owner.template || !this.cell.closest("tbody.bindable")) return;
		
		var suppress = ninegrid.j.querySelectorAll(this.cell).attr('suppress');
		if (suppress) suppress = parseInt(suppress);
		
		if (suppress && !isNaN(suppress)) {
			
			var tr = this.cell.closest("tr");
			var arrSuppress = [];
			
			$("th,td", tr).each((i,el) => {
				var otherSuppress = ninegrid.j.querySelectorAll(el).attr('suppress');
				if (otherSuppress && el.dataset.row) {
					otherSuppress = parseInt(otherSuppress);
					
					if (!isNaN(otherSuppress) && otherSuppress <= suppress) arrSuppress.push(otherSuppress);
				}
			});
			
			arrSuppress.sort();
			
			
			var bSuppress = false;
			
			if (parseInt(tr.sectionRowIndex / this.owner.template.length) > 0) {
				for (var v of arrSuppress) {
					if (v > suppress) break;

					var currRow = parseInt(this.cell.dataset.row);
					var prevRow = currRow - 1;
					var currData = this.cell.closest("tr").data;
					var prevData = this.owner.data.get(prevRow);
					
					var matrixRow= this.cell.dataset.matrixRow;
					var suppressCell = this.owner.body.querySelector(`tbody.bindable [suppress="${v}"][data-matrix-row="${this.cell.dataset.matrixRow}"]`);
					var currValue = suppressCell.dataset.expr ? this.getExprValue(suppressCell.dataset.expr, currData, currRow) : currData[suppressCell.dataset.bind];
					var prevValue = suppressCell.dataset.expr ? this.getExprValue(suppressCell.dataset.expr, prevData, prevRow) : prevData[suppressCell.dataset.bind];
					
					if (currValue != prevValue) {
						bSuppress = true;
						break;
					}
				}
			}
			else {
				bSuppress = true;
			}
			
			(bSuppress) ? ninegrid.j.querySelectorAll(this.cell).removeClass('suppress') : ninegrid.j.querySelectorAll(this.cell).addClass('suppress');
			if (!ninegrid.j.querySelectorAll(this.cell).hasClass("hidden")) {
				(bSuppress) ? ninegrid.j.querySelectorAll(this.cell).removeClass('hidden') : ninegrid.j.querySelectorAll(this.cell).addClass('hidden');
			}
			
			var currMatrixRow = parseInt(this.cell.dataset.matrixRow);
			var prevMatrixRow = currMatrixRow - 1;//this.owner.template.length;
			var prevCell = this.owner.body.querySelector(`tbody.bindable [data-col="${this.cell.dataset.col}"][data-matrix-row="${prevMatrixRow}"]`);
			
			if ($(prevCell).hasClass('suppress') && !ninegrid.j.querySelectorAll(this.cell).hasClass('suppress')) {
				ninegrid.j.querySelectorAll(prevCell).removeClass('last-none-suppress').addClass('last-suppress');
			}
			else if (!$(prevCell).hasClass('suppress') && ninegrid.j.querySelectorAll(this.cell).hasClass('suppress')) {
				ninegrid.j.querySelectorAll(prevCell).removeClass('last-suppress').addClass('last-none-suppress');
			}
			else {
				ninegrid.j.querySelectorAll(prevCell).removeClass('last-none-suppress').removeClass('last-suppress');
			}
		}
	};
	
	getExprValue = (expr, data, row, cell) => {
		
		//console.log(expr, data, row, cell);
		if (typeof expr !== "undefined") {
			try {
				
				row = parseInt(row);
				const fn = expr.replace("()", "");
				
				//console.log(fn, this.owner[fn]);
				
				if (this.owner[fn]) {
					return this.owner[fn].call(this, data, row,  this.cell);
				}

				return this.owner.exprFunction(expr).call(this, data, row, this.owner.data);
				//return this.owner.exprFunction2(expr).call(this, data, row, this.owner.data);
			} catch (e) {
				//console.error(e, expr, data, row);
				return ["NG-COMBO"].includes(this.tagName) ? "" : expr;
			}
		}
		else {
			return expr;
		}
	};
}

export class ngEditableEx extends ngCellEx
{
	constructor () {
		super();
	}

	connectedCallback() {

		super.connectedCallback();
		
		$("input,textarea", this.shadowRoot).on("change", (event) => {
			
			if (!this.closest("tbody")) return;

			switch (event.target.getAttribute('type')) {
			case "checkbox":
				this.value = $(event.target).is(':checked') ? this.trueValue : this.falseValue;
				break;
			
			case "radio":
				if (this.tagName == "NG-CHECKBOX") {
					this.selectAll(false);
				}
				this.value = $(event.target).val();
				break;

			default:
				var maxbyte = this.getAttribute("maxbyte");
				if (maxbyte) {
					maxbyte = parseInt(maxbyte);

					if (ninegrid.getByteLength(event.target.value) >= maxbyte) {

						event.target.value = ninegrid.cut(event.target.value, maxbyte);
					}
				}
				var v = $(event.target).val();
				this.value = ninegrid.j.querySelectorAll(this).attr("type") == "number" ? (isNaN(v) ? "" : Number(v)) : v;

				break;
			}

			this.owner.refreshData(this.cell.dataset.row);
		});
	};
}